import {Button, Card, Collapse, Form, OverlayTrigger, Popover, Table} from "react-bootstrap";
import {useEffect, useState} from "react";
import {changeStatus, getJobNotes, getMyJobs, getMyJobsDates} from "../service/jobService";
import LoadingSpin from "react-loading-spin";
import {convertDescriptionPrefix, covertJobTitle} from "../service/jobutil";
import JobExpand from "./JobNotes";
import {getCurrentUserInfo} from "../service/authService";
import Highlighter from "react-highlight-words";
import ImageUpload from "./ImageUpload";
import ImageGallary from "./ImageGallary";
import DatePicker from "react-datepicker";

import "../css/react-datepicker.css";


function toDateString(inputDate) {
    return new Date(inputDate.getTime() - (inputDate.getTimezoneOffset() * 60000)).toISOString().substring(0, 10)
}

export default function Workers(props) {
    const now = new Date();
    const [selectedDateString, setSelectedDateString] = useState(toDateString(now));
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [myJobDate, setMyJobDate] = useState([])

    const [isLoading, setIsLoading] = useState(false)
    const [radioValue, setRadioValue] = useState('ALL');
    const [filteredData, setFilteredData] = useState([])
    const [tableData, setTableData] = useState();
    const [statusCounts, setStatusCounts] = useState({})
    const [imagesDict, setImagesDict] = useState({});
    const [searchText, setSearchText] = useState("")
    const [expandStatus, setExpandStatus] = useState({})
    const [expandMessages, setExpandMessages] = useState({})
    const [globalMessage, setGlobalMessage] = useState("")
    const [jobNotesDict, setJobNotesDict] = useState({})
    const [weekday, setWeekday] = useState(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]);

    useEffect(() => {
        refreshJobList(selectedDateString);
        refreshJobDate(new Date())
        let currentUser = getCurrentUserInfo()
        if (currentUser !== undefined) {
            window.smartlook('identify', currentUser.cosCustomerId, {
                name: currentUser.cosCustomerName,
                ...currentUser
            })
        } else {
            window.smartlook('anonymize')
        }

    }, []);

    function refreshJobDate(date) {
        getMyJobsDates(date).then(response => {
            if (response.status === 200) {
                response.json().then(dateStrings => {
                    const dateObjects = dateStrings.map(dateString => new Date(dateString));
                    setMyJobDate(dateObjects)
                });
            }
        })
    }

    function refreshJobList(currentSelectionDate) {
        setIsLoading(true)

        getMyJobs(currentSelectionDate, currentSelectionDate).then(response => {
            if (response.status === 200) {

                response.json().then(result => {
                    const counts = {};
                    for (const job of result) {
                        counts[job.status] = counts[job.status] ? counts[job.status] + 1 : 1;
                    }
                    setStatusCounts(counts)
                    filterTables(result, radioValue, searchText)
                })
            } else {
                response.text().then(result => {
                    try {
                        setGlobalMessage(JSON.parse(result.message))
                    } catch (e) {
                        setGlobalMessage(result)
                    }
                })
            }
        }).catch(error => console.log('error', error))
            .finally(() => {
                setIsLoading(false)
            });
    }

    function getHighlightedText(str) {
        let pattern = "⚠️"
        const result = str.match(new RegExp(pattern + "(.*)" + pattern));
        let ret = result ? result : [];
        ret.push("Please bring sofabed linens")
        return ret

    }

    function handleSelect(eventDate) {
        setSelectedDate(eventDate)
        setSelectedDateString(toDateString(eventDate));
        refreshJobList(toDateString(eventDate));
    }

    function stringToDate(dateString) {
        let parts = dateString.split('-');
        let mydate = new Date(parts[0], parts[1] - 1, parts[2]);
        return mydate
    }

    function filterTables(rawdata, radioValue, searchText) {
        rawdata.sort(function (a, b) {
            if (a.check_in && b.check_in) {
                if (a.check_in.localeCompare(b.check_in) === 0) {
                    return a.cos_job_id.localeCompare(b.cos_job_id)
                } else {
                    return a.check_in.localeCompare(b.check_in)
                }

            }

            if (a.check_in) {
                return -1
            }
            if (b.check_in) {
                return 1
            }
            return a.cos_job_id?.localeCompare(b.cos_job_id)
        });


        let tempData
        if (radioValue !== 'ALL') {
            tempData = rawdata.filter(item => item.status && item.status.includes(radioValue));
        } else {
            tempData = rawdata.filter(item => item.status && item.status !== 'Cancelled');
        }
        //cos_customer_name, username, agent_name, phone, email
        if (searchText && searchText.length > 0) {
            tempData = tempData.filter(item => (item.full_address && item.full_address.toLowerCase().includes(searchText.toLowerCase()) || (item.agent_name && item.agent_name.toLowerCase().includes(searchText.toLowerCase())) || (item.cos_customer_name && item.cos_customer_name.toLowerCase().includes(searchText.toLowerCase())) || (item.phone && item.phone.toLowerCase().includes(searchText.toLowerCase())) || (item.email && item.email.toLowerCase().includes(searchText.toLowerCase())) || (item.cos_job_id && item.cos_job_id.toLowerCase().includes(searchText.toLowerCase()))));
        }
        setTableData(rawdata)
        setFilteredData(tempData)
    }

    function delta(x) {
        let d = stringToDate(selectedDateString)
        d.setDate(d.getDate() + x);
        setSelectedDate(d)
        setSelectedDateString(toDateString(d))
        refreshJobList(toDateString(d))
    }

    function refreshJobNotesList(cos_job_id) {
        setIsLoading(true)
        setGlobalMessage("")
        getJobNotes(cos_job_id).then(response => {
            if (response.status === 200) {
                response.json().then(result => {
                    setJobNotesDict({
                        ...jobNotesDict,
                        [`${cos_job_id}`]: result
                    })
                })
            } else {
                response.text().then(result => {
                    try {
                        setGlobalMessage(JSON.parse(result.message))
                    } catch (e) {
                        setGlobalMessage(result)
                    }
                })
            }
        })
            .catch(error => console.log('error', error))
            .finally(() => setIsLoading(false));
    }


    function clickExpand(job) {
        if (!expandStatus[job.cos_job_id]) {
            expandStatus[job.cos_job_id] = true
        } else {
            expandStatus[job.cos_job_id] = !expandStatus[job.cos_job_id]
        }
        setExpandStatus({
            ...expandStatus
        })
        if (expandStatus[job.cos_job_id] === true) {
            refreshJobNotesList(job.cos_job_id)
        }
    }

    function determinBorder(job) {
        switch (job.status) {
            case 'Scheduled':
                return 'primary'
            case 'InProgress':
                return 'warning'
            case 'ReadyForBilling':
                return 'success'
            default:
                return 'danger'
        }
    }

    function setImages(imagesArray, jobId) {
        setImagesDict({
            ...imagesDict,
            [jobId]: imagesArray
        })
    }


    function determinColor(job) {
        switch (job.status) {
            case 'Scheduled':
                return 'blue'
            case 'InProgress':
                return 'darkorange'
            case 'ReadyForBilling':
                return 'green'
            default:
                return 'red'
        }
    }

    function handleStatusChange(cos_job_id, targetStatus) {
        setIsLoading(true)
        setExpandMessages({})
        changeStatus(cos_job_id, targetStatus).then(response => {
            if (response.status === 200) {
                response.json().then(result => {
                    refreshJobList(selectedDateString)
                })
            } else if (response.status < 500) {
                response.json().then(result => {
                    let expandMessage = {}
                    expandMessage[cos_job_id] = result['message']
                    setExpandMessages({
                        ...expandMessage
                    });
                })
            } else {
                let expandMessage = {}
                expandMessage[cos_job_id] = "Update Job Status Failed"
                setExpandMessages({
                    ...expandMessage
                });
            }
        })
            .catch(error => console.log('error', error))
            .finally(() => setIsLoading(false));
    }

    const currentUser = getCurrentUserInfo()
    const popover = (
        <Popover id="popover-basic">
            <Popover.Header as="h3">My Details</Popover.Header>
            <Popover.Body>
                <li>Username: {currentUser.username}</li>
                <li>Name: {currentUser.cosCustomerName}</li>
                <li>Id: {currentUser.cosCustomerId}</li>
                <li>Phone: {currentUser.phone}</li>
                <li>Email: {currentUser.email}</li>
            </Popover.Body>
        </Popover>
    );


    return (
        <>
            <div style={{display: "flex", alignItems: "center", justifyContent: "center", marginTop: "2px"}}>
                <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
                    <img width={"38px"} height={"38px"}
                         src={"/" + process.env.PUBLIC_URL + (!isLoading ? "favicon.png" : "loading.gif")}
                         alt={"UrbanAide Logo"}/>
                </OverlayTrigger>
                <Button variant="outline-secondary" disabled={isLoading} onClick={() => {
                    delta(-1)
                }}>{'<'}</Button>
                <div style={{flexGrow: 2}}>
                    <DatePicker
                        onMonthChange={refreshJobDate}
                        highlightDates={myJobDate}
                        onChange={handleSelect}
                        selected={selectedDate}
                    />
                </div>

                <Button variant="outline-secondary" disabled={isLoading} onClick={() => {
                    delta(1)
                }}>{'>'}</Button>

                <div style={{
                    marginLeft: "3px",
                    marginRight: "3px",
                    marginTop: "0px",
                    border: "1px solid #ced4da",
                    borderRadius: "5px",
                    height: "38px",
                    minWidth: "38px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <div>
                        {weekday[stringToDate(selectedDateString).getDay()]}
                    </div>
                </div>
                <Button variant="secondary" size={"sm"}
                        style={{
                            height: "36px",
                            marginRight: "4px",
                        }}
                        onClick={() => {
                            localStorage.removeItem("cosToken");
                            window.location.href = "/login"
                        }
                        }
                        disabled={isLoading}
                >Logout</Button>


            </div>
            <div>
                <pre>{globalMessage}</pre>
            </div>
            <div>
                <>
                    {filteredData.length > 0 ? filteredData.map((job, idx) => (
                            <Card
                                style={{textAlign: "left"}}
                                border={determinBorder(job)}
                                bg={"light"}
                                key={'jobCard' + idx}
                                text={'dark'}
                                className="mb-2"
                            >
                                <Card.Header
                                    onClick={() => {
                                        clickExpand(job);
                                    }}><span style={{display: "flex"}}>
                                    <span><b>Job ID: {job.cos_job_id}</b></span>
                                    <span style={{marginLeft: "auto", color: determinColor(job)}}><b>{
                                        job.status
                                    }</b></span>
                                </span></Card.Header>
                                <Card.Body>
                                    <Card.Text onClick={() => {
                                        clickExpand(job);
                                    }}>
                                        {covertJobTitle(job) + ' '}
                                    </Card.Text>


                                    <Collapse in={expandStatus[job.cos_job_id] ? expandStatus[job.cos_job_id] : false}>

                                        <div>
                                            <div onClick={() => {
                                                clickExpand(job);
                                            }}>
                                                <Highlighter
                                                    highlightStyle={{backgroundColor: "#ffd54f"}}
                                                    searchWords={[...getHighlightedText(convertDescriptionPrefix(job, false))]}
                                                    autoEscape={true}
                                                    textToHighlight={convertDescriptionPrefix(job, false)}
                                                /></div>

                                            <div style={{display: "flex", marginTop: "10px"}}>
                                                <span>{job.date}</span>
                                                <a style={{marginLeft: "auto"}} target="_blank"
                                                   href={"https://maps.google.com/?q=" + job.full_address}>Show maps</a>
                                            </div>
                                            <div style={{marginTop: "10px"}}>
                                                <Highlighter
                                                    highlightStyle={{backgroundColor: "#ffd54f"}}
                                                    searchWords={[...getHighlightedText(job.description)]}
                                                    autoEscape={true}
                                                    textToHighlight={job.description}
                                                />
                                            </div>


                                            <div style={{marginTop: "10px"}}>
                                                <Table striped bordered hover size="sm">
                                                    <thead>
                                                    <tr>
                                                        <th>Bed</th>
                                                        <th>Bath</th>
                                                        <th>Sofa</th>
                                                        <th>King</th>
                                                        <th>Queen</th>
                                                        <th>Single</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        <td>{job.bedroom === 0 ? "-" : job.bedroom}</td>
                                                        <td>{job.bathroom === 0 ? "-" : job.bathroom}</td>
                                                        <td>{job.sofabed === 0 ? "-" : job.sofabed}</td>
                                                        <td>{job.king === 0 ? "-" : job.king}</td>
                                                        <td>{job.queen === 0 ? "-" : job.queen}</td>
                                                        <td>{job.single === 0 ? "-" : job.single}</td>
                                                    </tr>
                                                    </tbody>
                                                </Table>
                                            </div>


                                            <div>
                                                <JobExpand job={job}
                                                           jobNoteList={jobNotesDict[job.cos_job_id]}
                                                           refreshJobNotesList={refreshJobNotesList}

                                                           open={expandStatus[job.cos_job_id]}/>
                                            </div>


                                            <div style={{display: "flex", marginTop: "1px"}}>
                                                <Button style={{marginLeft: "1px", width: "100%"}} variant="outline-primary"
                                                        size={"sm"} disabled={isLoading || job.status !== 'Scheduled'}
                                                        onClick={() => handleStatusChange(job.cos_job_id, 'InProgress')}
                                                >
                                                    {isLoading ? <LoadingSpin
                                                        primaryColor="grey"
                                                        size="18px"/> : 'Start Job'}
                                                </Button>
                                                <Button style={{marginLeft: "1px", width: "100%"}}
                                                        variant="outline-primary"
                                                        size={"sm"} disabled={isLoading || job.status !== 'InProgress'}
                                                        onClick={() => handleStatusChange(job.cos_job_id, 'ReadyForBilling')}
                                                >
                                                    {isLoading ? <LoadingSpin
                                                        primaryColor="grey"
                                                        size="18px"/> : 'Complete Job'}
                                                </Button>
                                                <Button style={{marginLeft: "1px", width: "100%"}}
                                                        variant="outline-secondary"
                                                        size={"sm"} disabled={isLoading || job.status === 'Cancelled'}
                                                        onClick={() => handleStatusChange(job.cos_job_id, 'Scheduled')}
                                                >
                                                    {isLoading ? <LoadingSpin
                                                        primaryColor="grey"
                                                        size="18px"/> : 'Revert to Scheduled'}
                                                </Button>
                                            </div>
                                            {expandStatus[job.cos_job_id] && <>
                                            <div><ImageUpload job={job}
                                                              images={imagesDict[job.cos_job_id]}
                                                              setImages={setImages}/></div>
                                            <div><ImageGallary job={job}
                                                               images={imagesDict[job.cos_job_id]}
                                                               setImages={setImages}/></div></>}
                                            <div>
                                                <pre>{expandMessages[job.cos_job_id]}</pre>
                                            </div>
                                        </div>
                                    </Collapse>

                                </Card.Body>


                            </Card>
                        ))

                        : <div style={{
                            height: "200px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <span>No Job Allocated to {currentUser.cosCustomerName} <br/>
                                {weekday[stringToDate(selectedDateString).getDay()]} {selectedDateString}, Please Check Date.</span>
                        </div>
                    }
                </>


            </div>
        </>

    )

}
